(function(){'use strict';
var timezone='America/Los_Angeles';
var localeMap={en:'en-US',es:'es-ES',ja:'ja-JP',ko:'ko-KR',fr:'fr-FR',de:'de-DE',it:'it-IT',pt:'pt-BR',fil:'fil-PH','zh-hans':'zh-CN','zh-hant':'zh-TW',ar:'ar'};
var zoneMap={en:'SV',es:'hora de Silicon Valley',ja:'シリコンバレー時間',ko:'실리콘밸리 시간',fr:'heure de la Silicon Valley',de:'Silicon-Valley-Zeit',it:'ora della Silicon Valley',pt:'Horário do Vale do Silício',fil:'Oras sa Silicon Valley','zh-hans':'硅谷时间','zh-hant':'矽谷時間',ar:'توقيت وادي السيليكون'};
function lang(){
 var raw=(document.documentElement.lang||'en').toLowerCase().replace('_','-');
 var prefix=location.pathname.split('/').filter(Boolean)[0]||'';
 if(/^(en|es|ja|ko|fr|de|it|fil|tl|pt-br|zh-hans|zh-hant|zh|zh-tw|zh-cn|ar)$/.test(prefix)) raw=prefix;
 if(/^zh-(hant|tw|hk)/.test(raw))return 'zh-hant';
 if(/^zh/.test(raw))return 'zh-hans';
 if(/^(fil|tl)/.test(raw))return 'fil';
 if(/^pt/.test(raw))return 'pt';
 var short=raw.split('-')[0];return localeMap[short]?short:'en';
}
function clock(){
 var el=document.querySelector('.logo-container .date-time-container,.date-time-container');
 if(!el){
  var anchor=document.querySelector('.logo-container,.kolak-blog-search,.news-container,.article-container,main');
  if(!anchor)return null;
  el=document.createElement('div');el.className='date-time-container kolak-blog-time-fallback';
  if(anchor.classList.contains('logo-container'))anchor.appendChild(el);
  else anchor.parentNode.insertBefore(el,anchor);
 }
 if(!el.querySelector('.date')){var d=document.createElement('div');d.className='date';el.appendChild(d);}
 if(!el.querySelector('.time')){var t=document.createElement('div');t.className='time';el.appendChild(t);}
 return el;
}
function update(){
 var el=clock();if(!el)return;
 // Avoid a duplicate when the site's generic missing-page clock loads first.
 var legacy=document.getElementById('kolak-fallback-datetime');
 if(legacy && legacy!==el) legacy.style.display='none';
 var l=lang(),locale=localeMap[l]||localeMap.en,now=new Date();try{
 var d,t;
 if(l==='en'){
  d=new Intl.DateTimeFormat(locale,{timeZone:timezone,month:'numeric',day:'numeric',year:'numeric'}).format(now);
  t=new Intl.DateTimeFormat(locale,{timeZone:timezone,hour:'numeric',minute:'2-digit',hour12:true}).format(now)+' SV';
 }else{
  d=new Intl.DateTimeFormat(locale,{timeZone:timezone,year:'numeric',month:['ar','es','fr','de','it','pt','fil'].includes(l)?'short':'numeric',day:'numeric'}).format(now);
  t=new Intl.DateTimeFormat(locale,{timeZone:timezone,hour:'numeric',minute:'2-digit',hour12:!['fr','de','it','pt'].includes(l)}).format(now)+' — '+zoneMap[l];
 }
 el.querySelector('.date').textContent=d;el.querySelector('.time').textContent=t;
 el.setAttribute('lang',locale);el.setAttribute('dir',l==='ar'?'rtl':'ltr');el.setAttribute('role','timer');
 }catch(e){console.error('[KOLAK] Blog date/time',e);}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update);else update();
window.setInterval(update,15000);window.addEventListener('pageshow',update);
document.addEventListener('visibilitychange',function(){if(!document.hidden)update();});
document.addEventListener('shopify:section:load',update);
})();
